import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3577937642/src/app/[locale]/(site)/_components/LandingHomePage.tsx");
